// import store from '../store/index'

const homeRouter = [{
        path: '',
        redirect: 'user'
    },
    {
        path: 'user',
        meta: {
            title: '2020北京公益慈善汇展-首页',
        },
        component: () =>
            import ('../views/Children/user'),

    },
    {
        path: 'orgInfo',
        meta: {
            title: '2020北京公益慈善汇展-机构信息',
        },
        component: () =>
            import ('../views/Children/orgInfo'),

    },
    {
        path: 'orgShop',
        meta: {
            title: '2020北京公益慈善汇展-网店',
        },
        component: () =>
            import ('../views/Children/orgShop'),

    },
    {
        path: 'shop',
        meta: {
            title: '网店展示',
        },
        component: () =>
            import ('../views/Children/shop'),

    },
    {
        path: 'projectList',
        meta: {
            title: '2020北京公益慈善汇展-项目申报',
        },
        component: () =>
            import ('../views/Children/projectList'),

    },
    {
        path: 'addProject',
        meta: {
            title: '2020北京公益慈善汇展-项目申报',
        },

        component: () =>
            import ('../views/Children/addProject'),
    },
    {
        path: 'projectDetail',
        meta: {
            title: '2020北京公益慈善汇展-项目申报',
        },
        component: () =>
            import ('../views/Children/projectDetail'),

    },
    {
        path: 'addOrg',
        meta: {
            title: '2020北京公益慈善汇展-项目申报',
        },

        component: () =>
            import ('../views/Children/addOrg'),
    },
    {
        path: 'projectOrg',
        meta: {
            title: '2020北京公益慈善汇展-机构信息',
        },
        component: () =>
            import ('../views/Children/projectOrg'),

    },
    {
        path: 'projectInfo',
        meta: {
            title: '2020北京公益慈善汇展-项目信息',
        },
        component: () =>
            import ('../views/Children/projectInfo'),

    },
    {
        path: 'integral',
        meta: {
            title: '2020北京公益慈善汇展-积分管理',
        },
        component: () =>
            import ('../views/Children/integral'),

    },
    {
        path: 'seting',
        meta: {
            title: '2020北京公益慈善汇展-帐号设置',
        },
        component: () =>
            import ('../views/Children/seting'),

    },
    {
        path: 'message',
        meta: {
            title: '2020北京公益慈善汇展-留言管理',
        },
        component: () =>
            import ('../views/Children/message'),

    }



]
export default homeRouter